import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Optimizes an image URL using Cloudflare's on-the-fly resizing.
 * Only applies to assets hosted on assets.auxodev.dk.
 */
export function getOptimizedImageUrl(url, options = {}) {
  if (!url || typeof url !== 'string' || !url.includes('assets.auxodev.dk')) {
    return url;
  }
  
  // If it already contains cdn-cgi/image, don't double wrap
  if (url.includes('/cdn-cgi/image/')) {
    return url;
  }

  const { width, height, quality = 80, format = 'auto', fit = 'cover' } = options;
  
  const params = [];
  if (width) params.push(`width=${width}`);
  if (height) params.push(`height=${height}`);
  if (quality) params.push(`quality=${quality}`);
  if (format) params.push(`format=${format}`);
  if (fit && (width || height)) params.push(`fit=${fit}`);
  
  const paramString = params.join(',');
  
  return url.replace('https://assets.auxodev.dk/', `https://assets.auxodev.dk/cdn-cgi/image/${paramString}/`);
}
